import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseService } from '@mt-ng2/base-service';
import { ICustomerModifiedHour } from '../model/interfaces/customer-modified-hour';

export const emptyModifiedCustomerHour: ICustomerModifiedHour = {
    CustomerId: null,
    EndTime: null,
    Id: 0,
    OnDate: null,
    StartTime: null,
};

@Injectable()
export class CustomerModifiedHourService extends BaseService<ICustomerModifiedHour> {
    constructor(public http: HttpClient) {
        super('/customer-modified-hours', http);
    }

    getEmptyCustomerModifiedHour(): ICustomerModifiedHour {
        return { ...emptyModifiedCustomerHour };
    }
}
